<template>
  <v-app>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <v-container fluid>
              <v-card-title>
                <v-spacer />
                <v-spacer />
                <v-btn
                  :loading="loading"
                  @click="openInsert()"
                  class="submit-btn"
                >
                  <v-icon>mdi-plus</v-icon>
                  اضافه کردن
                </v-btn>
              </v-card-title>
              <v-divider />

              <div class="row align-content-center justify-content-center">
                <v-card-title
                  class="align-content-center justify-content-center"
                  >لیست کلیه محصولات
                </v-card-title>
                <div class="col-md-12 p-5">
                  <v-data-table
                    v-if="productData"
                    :headers="headers"
                    :items="productData"
                    item-key="_id"
                    :footer-props="footerProps"
                    :options.sync="options"
                    :header-props="headerProps"
                    :rows-per-page-items="[10, 20, 30, 40]"
                    :server-items-length="20"
                    :loading="loading"
                    :expanded.sync="expanded"
                    show-expand
                    class="elevation-1"
                  >
                    <template v-slot:item.amount.$numberDecimal="{ item }">
                      <v-chip color="green" label small class="text-white">
                        {{ price(item.price.$numberDecimal) }}
                      </v-chip>
                    </template>
                    <template v-slot:item.serviceId="{ item }">
                      <v-chip color="green" label small class="text-white">
                        {{ $options.filters.serviceTypeNumber(item.serviceId) }}
                      </v-chip>
                    </template>
                    <template v-slot:item.created_at="{ item }">
                      <v-chip color="green" label small class="text-white">
                        {{ persian($options.filters.onlyDate(item.createdAt)) }}
                      </v-chip>
                    </template>
                    <template v-slot:item.time="{ item }">
                      <v-chip color="orange" label small class="text-white">
                        {{ persian($options.filters.onlyTime(item.createdAt)) }}
                      </v-chip>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <v-row>
                        <v-col cols="12">
                          <v-btn class="btn-accept" @click="openEdit(item)"
                            >ویرایش</v-btn
                          >
                        </v-col>
                      </v-row>
                    </template>
                  </v-data-table>
                </div>
              </div>
            </v-container>
          </div>
        </div>
      </div>
    </div>

    <!--asdasd-->

    <custom-popup
      v-model="dialogInsert"
      :cons="editCons"
      hide-overlay
      scrollable
    >
      <template v-slot:extension></template>

      <v-card-text class="position-relative pa-0">
        <v-card>
          <v-card-text>
            <v-row>
              <v-text-field
                class="m-1"
                outlined
                label="نام(لاتین)"
                v-model="newProduct.name"
              ></v-text-field>
            </v-row>

            <v-row>
              <v-text-field
                class="m-1"
                outlined
                label="نام فارسی"
                v-model="newProduct.description"
              ></v-text-field>
            </v-row>

            <v-row>
              <v-select
                v-model="newProduct.serviceId"
                :items="services"
                item-text="nameLand"
                item-value="id"
                label="انتخاب سرویس"
                outlined
                dense
              ></v-select>
            </v-row>

            <v-row>
              <v-radio-group row v-model="newProduct.otherCompany">
                <v-radio
                  label="محصول شرکت"
                  color="primary"
                  :value="0"
                ></v-radio>
                <v-radio
                  label="خرید از شرکت های دیگر"
                  color="primary"
                  :value="1"
                ></v-radio>
              </v-radio-group>
            </v-row>

            <v-row>
              <v-text-field
                class="m-1"
                outlined
                label="مالیات"
                type="number"
                append-icon="mdi-percent"
                v-model="newProduct.tax"
              ></v-text-field>
            </v-row>

            <v-row align="center" class="ma-0 pt-3">
              <v-col cols="6" lg="6" class="pt-0">
                <v-chip>کارمزد</v-chip>
              </v-col>

              <v-col cols="3" lg="3" class="pt-0">
                <v-text-field
                  append-icon="mdi-percent"
                  label="درصد"
                  v-model="newProduct.commissionPercent"
                  outlined
                  id="propKey"
                />
              </v-col>
              <v-col cols="3" lg="3" class="pt-0">
                <price-input
                  label="مبلغ"
                  v-model="newProduct.commissionPrice"
                  outlined
                  id="propValue"
                />
              </v-col>
            </v-row>

            <v-row>
              <price-input
                :dense="false"
                :label="'قیمت'"
                v-model="newProduct.price"
              ></price-input>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>

      <template v-slot:action></template>
    </custom-popup>

    <custom-popup
      v-model="dialogEdit"
      :cons="editDialogCons"
      hide-overlay
      scrollable
    >
      <template v-slot:extension></template>

      <v-card-text class="position-relative pa-0">
        <v-card>
          <v-card-text>
            <v-row>
              <v-text-field
                class="m-1"
                outlined
                label="نام(لاتین)"
                v-model="editProduct.name"
              ></v-text-field>
            </v-row>

            <v-row>
              <v-text-field
                class="m-1"
                outlined
                label="نام فارسی"
                v-model="editProduct.description"
              ></v-text-field>
            </v-row>
            <v-row>
              <v-select
                v-model="editProduct.serviceId"
                :items="services"
                item-text="nameLand"
                item-value="id"
                label="انتخاب سرویس"
                outlined
                dense
              ></v-select>
            </v-row>

            <v-row>
              <v-radio-group row v-model="editProduct.otherCompany">
                <v-radio
                  label="محصول شرکت"
                  color="primary"
                  :value="0"
                ></v-radio>
                <v-radio
                  label="خرید از شرکت های دیگر"
                  color="primary"
                  :value="1"
                ></v-radio>
              </v-radio-group>
            </v-row>

            <v-row align="center" class="ma-0 pt-3">
              <v-col cols="6" lg="6" class="pt-0">
                <v-chip>کارمزد</v-chip>
              </v-col>

              <v-col cols="3" lg="3" class="pt-0">
                <v-text-field
                  label="درصد"
                  v-model="editProduct.commissionPercent"
                  outlined
                  id="propKey"
                />
              </v-col>
              <v-col cols="3" lg="3" class="pt-0">
                <price-input
                  label="مبلغ"
                  v-model="editProduct.commissionPrice"
                  outlined
                  id="propValue"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-text-field
                class="m-1"
                outlined
                label="مالیات"
                type="number"
                append-icon="mdi-percent"
                v-model="editProduct.tax"
              ></v-text-field>
            </v-row>

            <v-row>
              <price-input
                :dense="false"
                :label="'قیمت'"
                v-model="editProduct.price"
              ></price-input>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
    </custom-popup>

    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <v-card-title> </v-card-title>
        <v-card-text>
          <v-container>
            <v-row v-if="dynamic">
              <v-flex class="p-2" xs12 sm12 md12 xl12 lg12>
                <price-input
                  v-model="dynamicPrice"
                  text-center="true"
                  label="قیمت داینامیک"
                />
              </v-flex>
            </v-row>

            <v-row>
              <v-flex class="p-2" xs12 sm12 md12 xl12 lg12>
                <v-text-field
                  v-model="count"
                  type="number"
                  label="تعداد"
                  outlined
                  dense
                />
              </v-flex>
            </v-row>

            <v-row>
              <v-flex class="p-2" xs12 sm12 md12 xl12 lg12>
                <v-btn class="btn-submit" @click="buyProduct">خرید</v-btn>
              </v-flex>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
export default {
  name: "AdminNotifications",
  data() {
    return {
      services: [],
      categories: [],
      dialogInsert: false,
      dialogEdit: false,
      newProduct: {
        name: "",
        serviceId: "",
        description: "",
        otherCompany: false,
        tax: 0,
        commissionPercent: 0,
        commissionPrice: 0,
        price: 0,
      },
      editProduct: {
        _id: "",
        name: "",
        serviceId: "",
        description: "",
        otherCompany: false,
        commissionPercent: 0,
        commissionPrice: 0,
        tax: "",
        price: 0,
      },
      editCons: {
        title: "اضافه کردن محصول",
        buttons: [{ text: "", type: "submit", handler: this.createProduct }],
      },
      editDialogCons: {
        title: "ویرایش محصول",
        buttons: [{ text: "", type: "submit", handler: this.editProduct }],
      },
      walletData: {
        balance: 0,
      },
      productData: [],
      headerProps: {
        sortByText: "نمایش بر ساس",
      },
      data: [],
      dialog: false,
      dynamicPrice: 0,
      productId: null,
      description: null,
      isFilter: false,
      footerProps: {
        itemsPerPageText: "تعداد ردیف: ",
        itemsPerPageAllText: "همه",
        itemsPerPageOptions: [10, 25, 50, 100, 200, 400],
        pageText: "از",
        showCurrentPage: true,
        showFirstLastPage: true,
      },
      expanded: [],
      length: null,
      singleExpand: false,
      loading: false,
      options: {},
      headers: [
        {
          text: "شناسه",
          value: "_id",
          align: "center",
          class: "font-weight-bold h6",
        },
        {
          text: "نام",
          value: "name",
          align: "center",
          class: "font-weight-bold h6",
          sortable: false,
        },
        {
          text: "نام سرویس",
          value: "serviceId",
          align: "center",
          class: "font-weight-bold h6",
          sortable: false,
        },
        {
          text: "شناسه محصول",
          value: "uniqueId",
          align: "center",
          class: "font-weight-bold h6",
          sortable: false,
        },
        {
          text: "مبلغ",
          value: "price.$numberDecimal",
          align: "center",
          class: "font-weight-bold h6",
        },
        {
          text: "مالیات",
          value: "tax",
          align: "center",
          class: "font-weight-bold h6",
        },
        {
          text: "تاریخ",
          value: "created_at",
          align: "center",
          class: "font-weight-bold h6",
        },
        {
          text: "ساعت",
          value: "time",
          align: "center",
          class: "font-weight-bold h6",
        },
        {
          text: "توضیحات",
          value: "description",
          align: "center",
          class: "font-weight-bold h6",
          sortable: false,
        },
        { text: "", value: "data-table-expand" },
      ],
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
      count: 0,
      dynamic: true,
      urlNotif: "notificationAdmin",
    };
  },
  methods: {
    async openInsert() {
      this.dialogInsert = true;
      try {
        this.services = await this.getService();
      } catch (error) {
        console.error("Failed to fetch services:", error);
        this.$toast.error("خطا در دریافت سرویس‌ها");
      } finally {
      }
      // this.services = this.getService().data
    },
    async openEdit(item) {
      this.dialogEdit = true;
      try {
        this.services = await this.getService(); // منتظر دریافت داده‌ها
      } catch (error) {
        console.error("Failed to fetch services:", error);
        this.$toast.error("خطا در دریافت سرویس‌ها");
      } finally {
      }
      //   this.services = this.getService().data;
      this.editProduct.price = item.price.$numberDecimal;
      this.editProduct._id = item._id;
      this.editProduct.serviceId = item.serviceId;
      this.editProduct.commissionPercent = item.commissionPercent
        ? item.commissionPercent
        : 0;
      this.editProduct.commissionPrice = item.commissionPrice
        ? item.commissionPrice
        : 0;
      this.editProduct.otherCompany = item.otherCompany ? 1 : 0;
      this.editProduct.description = item.description;
      this.editProduct.tax = item.tax;
      this.editProduct.name = item.name;
    },
    createProduct() {
      this.requestApiPostWallet("product", this.newProduct)
        .then(({ data }) => {
          this.loading = false;
          this.getProducts();
          this.dialogInsert = false;
        })
        .catch(({ response }) => {
          this.loading = false;
        });
    },
    getCategories() {
      this.loading = true;

      this.requestApiGet("category/get-all", { permission: true })
        .then(({ data }) => {
          let category = [];
          for (let i = 0; i < data.length; i++) {
            category.push({
              text:
                data[i].name + " \t" + "( " + data[i].service.nameLand + " )",
              value: data[i].id,
            });
          }
          this.categories = category;
          this.loading = false;
        })
        .catch(({ response }) =>
          console.log("error in get provinces: ", response)
        );
    },
    getProducts() {
      this.loading = true;
      this.requestApiGetWallet("product")
        .then(({ data }) => {
          console.log(data.data);
          this.productData = data.data;
          this.loading = false;
        })
        .catch(({ response }) => {
          this.loading = false;
        });
    },
    editProduct() {
      this.loading = true;
      this.requestApiPostWallet("product/update", { ...this.editProduct })
        .then((data) => {
          this.$toast.success("ویرایش با موفقیت انجام شد ");
          this.loading = false;
          this.dialogEdit = false;
          this.getProducts();
        })
        .catch(({ response }) => {
          this.$toast.error("خطا در ویرایش");
          this.loading = false;
        });
    },

    buyProductDialog(dynamic, productId, count, dynamicPrice) {
      this.dialog = true;
      this.dynamicPrice = dynamicPrice;
      this.dynamic = dynamic;
      this.productId = productId;
      this.count = count;
    },
    buyProduct() {
      this.dialog = true;
      let data = {};
      if (this.dynamic) {
        data = {
          productId: this.productId,
          count: this.count,
          dynamicPrice: this.dynamicPrice,
        };
      } else {
        data = {
          productId: this.productId,
          count: this.count,
        };
      }

      this.requestApiPostWallet("transactions/withdraw", data)
        .then((data) => {
          this.$toast.success("خرید با موفقیت انجام شد ");
          this.loading = false;
          this.dialog = false;
          this.newProduct = {};
          this.goReplace("admin/wallet");
        })
        .catch(({ response }) => {
          this.$toast.error("موجودی حساب شما کافی نمی باشد! ");
          this.loading = false;
        });
    },

    redirectTo() {
      if (this.count === 0) this.$toast.info("درحال بروزرسانی ...");
      if (this.count === 1) this.$toast.warning("درحال بروزرسانی ...");
      this.count++;
    },
    getUserNotification(url = this.urlNotif, query = this.tableProps) {
      this.loading = true;
      this.requestApiGet(url, query)
        .then(({ data }) => {
          this.loading = false;
          this.isFilter = true;
          this.data = data.data;
          this.length = data.total;
        })
        .catch(({ response }) => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getWallet();
    this.getProducts();
  },
  watch: {
    options(val) {
      if (this.isFilter) {
        this.tableProps.page = val.page;
        this.tableProps.length = val.itemsPerPage;
        this.tableProps.column = val.sortBy[0] ?? "id";
        if (!val.sortDesc[0]) this.tableProps.dir = "asc";
        else this.tableProps.dir = "desc";
        this.getUserNotification(this.urlNotif, this.tableProps);
      }
    },
  },
};
</script>

<style scoped>
pre {
  outline: 1px solid #ccc;
  padding: 5px;
  margin: 5px;
  background-color: #282828;
  color: white;
}

.string {
  color: green !important;
}

.number {
  color: darkorange !important;
}

.boolean {
  color: blue !important;
}

.null {
  color: magenta !important;
}

.key {
  color: red !important;
}
</style>
